import { useMutation } from '@tanstack/react-query';

import type { BinderUser, PermissionEnum } from 'src/api-sdk';
import type { MutationHookOptions } from 'src/types/global';
import { useAPI } from 'src/util/use-api';

type AddUserToBinderParams = {
  binderId: string;
  userId: string;
  permission: PermissionEnum;
};

export const useAddUserToBinder = (
  options: MutationHookOptions<
    BinderUser | undefined,
    Error,
    AddUserToBinderParams
  > = {}
) => {
  const { API } = useAPI();

  return useMutation({
    mutationFn: async ({
      binderId,
      userId,
      permission,
    }: AddUserToBinderParams) => {
      return (
        await API?.bindersAPI.bindersUsersCreate({
          binderId,
          binderUserRequest: {
            user: {
              external_id: userId,
            },
            permission,
          },
        })
      )?.data;
    },

    ...options,
  });
};
